import { Box, Card, Checkbox, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(136px, 1fr))',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.5, 0),
}));

export const InventoryCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: theme.spacing(1.5),
  border: theme.palette.mode === 'dark' ? `1px solid ${theme.palette.divider}` : 'none',
  boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
  transition: 'box-shadow 0.2s ease, transform 0.2s ease',
  cursor: 'pointer',
  '&:hover': {
    boxShadow:
      theme.palette.mode === 'dark'
        ? `0 4px 16px rgba(0, 0, 0, 0.35)`
        : '0 4px 12px rgba(0, 0, 0, 0.15)',
    transform: 'translateY(-2px)',
  },
}));

export const ImageWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  paddingTop: '100%',
  backgroundColor: theme.palette.action.hover,
  overflow: 'hidden',
}));

export const ItemThumbnail = styled('img')(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
}));

/** Lupa sobre la miniatura (esquina superior derecha; el checkbox queda a la izquierda). */
export const CardCheckbox = styled(Checkbox)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(0.75),
  left: theme.spacing(0.75),
  zIndex: 2,
  color: 'white',
  backgroundColor: alpha('#000', 0.4),
  borderRadius: '4px',
  padding: '4px',
  '&.Mui-checked': {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
  },
  '&:hover': {
    backgroundColor: alpha('#000', 0.5),
  },
}));

export const CardContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 1.25, 1, 1.25),
}));

export const CardActionsBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(0.5),
  paddingTop: theme.spacing(0.75),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const EmptyStateContainer = styled(Box)(({ theme }) => ({
  gridColumn: '1 / -1',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(8),
  textAlign: 'center',
}));
